import {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router';
import qs from 'qs';

import {useAuth} from 'context/auth-context';
import {useLoginBexio} from 'api/users';
import {PATH} from 'constants/common';
import {parseJwt} from 'helpers/common';
import styles from './BexioAuthPage.module.scss';
import AmnisLoader from 'components/ui/AmnisLoader/AmnisLoader';
import Alert from 'components/ui/Alert/Alert';
import {Link} from 'react-router-dom';
import {useGetTwoFALogin} from 'api/futurae';

const BexioAuthPage = () => {
    const location = useLocation();
    const history = useHistory();
    const {login, setToken} = useAuth();
    const {mutate: loginBexio, error} = useLoginBexio();
    const [loginToken, setLoginToken] = useState<string>('');
    const {mutate: authenticate2FA} = useGetTwoFALogin();

    const params = qs.parse(location.search, {ignoreQueryPrefix: true});

    const handleSuccess = (response: any) => {
        const {action, ...rest} = response;

        if (action === 'registration') {
            const userData = qs.stringify(rest, {encode: false});
            history.push(`${PATH.REGISTRATION_BEXIO}?${userData}`);
        }

        if (action === 'logged_in') {
            const {token} = response;
            const decodedToken = parseJwt(token);
            if (decodedToken.needs_2fa) {
                setLoginToken(token);
                setToken(token);
                authenticate2FA(
                    {token},
                    {
                        onSuccess: response => {
                            return login(response.token);
                        },
                        onError: () => setToken(null),
                    },
                );
            } else {
                login(token);
            }
        }
    };

    const handleLoginBexio = () => {
        const {code} = params;
        if (!code) return;
        loginBexio(
            {code: code.toString(), state: params.state},
            {
                onSuccess: handleSuccess,
            },
        );
    };

    useEffect(() => {
        if (params.code && params.state) {
            handleLoginBexio();
        }
    }, []); // eslint-disable-line

    if (error || params.error) {
        return (
            <>
                <div className={styles.container}>
                    <h3>Authorization failed</h3>
                    <Alert
                        message={
                            (params as any)?.error_description ||
                            (error as any)?.['hydra:description'] ||
                            'Something went wrong'
                        }
                        variant="danger"
                    />
                    <div className={styles.login} data-isolate>
                        Try again?
                        <Link to={PATH.REGISTRATION_BEXIO_INIT}>Login</Link>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className={styles.container}>
            <AmnisLoader />
            <h3>Authorization in progress...</h3>
        </div>
    );
};

export default BexioAuthPage;
